import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=1d89d65a&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
import style0 from "./Settings.vue?vue&type=style&index=0&id=1d89d65a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d89d65a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d89d65a')) {
      api.createRecord('1d89d65a', component.options)
    } else {
      api.reload('1d89d65a', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=1d89d65a&scoped=true", function () {
      api.rerender('1d89d65a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrganisationDetails/Settings.vue"
export default component.exports